// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__feMGQ","messages":"Chat_messages__3FvAp","dateDivider":"Chat_dateDivider__2Bjt4"};